<div class="w-full py-2 px-2" [formGroup]="formGroup">
  <label class="inline-flex items-center">
    <input
      type="checkbox"
      class="checkbox text-gray-800 cursor-pointer"
      [formControlName]="fields.fieldName"
      [id]="'option_' + fields.fieldName"
      (change)="onCheckboxChange()"
    />
    <span class="ml-2 text-2sm ms-2 text-gray-900">
      <ng-container
        *ngIf="
          fields.properties?.hyperlinkText &&
            formattedDisplayName.includes(fields.properties.hyperlinkText);
          else normalDisplayName
        "
      >
        {{
          formattedDisplayName.substring(
            0,
            formattedDisplayName.indexOf(fields.properties.hyperlinkText)
          )
        }}

        <a
          [href]="fields.properties.hyperlinkLink"
          target="_blank"
          class="text-blue underline"
        >
          {{ fields.properties.hyperlinkText }}
        </a>

        {{
          formattedDisplayName.substring(
            formattedDisplayName.indexOf(fields.properties.hyperlinkText) +
              fields.properties.hyperlinkText.length
          )
        }}
      </ng-container>

      <ng-template #normalDisplayName>
        {{ formattedDisplayName }}
      </ng-template>
    </span>
  </label>

  <!-- Validation Message -->
  <div *ngIf="showError" class="text-danger text-sm mt-1">
    You must accept the {{ fields.properties.hyperlinkText }}
  </div>
</div>
